module.exports = __webpack_public_path__ + "static/media/skipped.2df524a3.svg";